import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { CommunityMemberSkeleton as CommunityMemberSkeletonCompass } from "./CommunityMemberSkeletonCompass";
import { CommunityMemberSkeleton as CommunityMemberSkeletonUiKit } from "./CommunityMemberSkeletonUiKit";

export const CommunityMemberSkeleton = () => {
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return <CommunityMemberSkeletonCompass />;
  }

  return <CommunityMemberSkeletonUiKit />;
};
